import { render, staticRenderFns } from "./NewDashboardBanner.vue?vue&type=template&id=f92dc8c0"
import script from "./NewDashboardBanner.vue?vue&type=script&lang=ts"
export * from "./NewDashboardBanner.vue?vue&type=script&lang=ts"
import style0 from "./NewDashboardBanner.vue?vue&type=style&index=0&id=f92dc8c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports